import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CountryProvider } from "@/lib/country";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import { TreatmentsList, TreatmentDetail, HospitalsList, HospitalDetail, DoctorsList, DoctorDetail, CountriesList, CountryDetail } from "@/pages/Directory";
import Costs from "@/pages/Costs";
import Enquiry from "@/pages/Enquiry";
import Partner from "@/pages/Partner";
import { Admin, AdminLogin } from "@/pages/Admin";
import { BlogList, BlogDetail } from "@/pages/Blog";
import { Toaster } from "sonner";

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#00030E] flex flex-col">
      <Header/>
      <main className="flex-1">{children}</main>
      <Footer/>
      <ChatWidget/>
    </div>
  );
}

export default function App() {
  return (
    <CountryProvider>
      <BrowserRouter>
        <ScrollToTop/>
        <Toaster position="bottom-right" theme="dark"/>
        <Routes>
        <Route path="/" element={<Layout><Home/></Layout>}/>
        <Route path="/treatments" element={<Layout><TreatmentsList/></Layout>}/>
        <Route path="/treatments/:slug" element={<Layout><TreatmentDetail/></Layout>}/>
        <Route path="/hospitals" element={<Layout><HospitalsList/></Layout>}/>
        <Route path="/hospitals/:slug" element={<Layout><HospitalDetail/></Layout>}/>
        <Route path="/doctors" element={<Layout><DoctorsList/></Layout>}/>
        <Route path="/doctors/:slug" element={<Layout><DoctorDetail/></Layout>}/>
        <Route path="/countries" element={<Layout><CountriesList/></Layout>}/>
        <Route path="/countries/:slug" element={<Layout><CountryDetail/></Layout>}/>
        <Route path="/costs" element={<Layout><Costs/></Layout>}/>
        <Route path="/enquiry" element={<Layout><Enquiry/></Layout>}/>
        <Route path="/partner" element={<Layout><Partner/></Layout>}/>
        <Route path="/blog" element={<Layout><BlogList/></Layout>}/>
        <Route path="/blog/:slug" element={<Layout><BlogDetail/></Layout>}/>
        <Route path="/admin/login" element={<Layout><AdminLogin/></Layout>}/>
        <Route path="/admin" element={<Layout><Admin/></Layout>}/>
        <Route path="*" element={<Layout><div className="max-w-2xl mx-auto px-6 py-32 text-center"><h1 className="font-serif text-5xl text-[#F3E9EC]">Page not found</h1><p className="mt-4 text-[#F3E9EC]/60">The page you're looking for doesn't exist.</p></div></Layout>}/>
      </Routes>
    </BrowserRouter>
    </CountryProvider>
  );
}
